import { cn } from '@/common/lib/cn/cn'
import { Button } from '@/common/ui/Form/Button'
import { Icon } from '@/common/ui/Icon'

import type { BrandPickerValue } from './BrandPicker'
import { BrandPickerDialog } from './BrandPickerDialog'
import { closeBrandPickerDialog } from './closeBrandPickerDialog'

type BrandFieldProps = {
    modalId: string
    value: BrandPickerValue
    onChange: (brand: BrandPickerValue) => void
    placeholder?: string
    title?: string
    className?: string
    isSaving?: boolean
    error?: unknown
}

export const BrandField = ({
    modalId,
    value,
    onChange,
    placeholder = 'Не указан',
    title,
    className,
    isSaving,
    error,
}: BrandFieldProps) => {
    const handleSave = (brand: BrandPickerValue) => {
        onChange(brand)
        closeBrandPickerDialog(modalId)
    }

    return (
        <>
            <div
                className={cn(
                    'flex w-full items-center justify-between gap-3 rounded-[8px] bg-[rgba(255,255,255,0.08)] px-4 py-3',
                    className
                )}
            >
                <span className='truncate text-sm text-white'>{value?.name ?? placeholder}</span>
                <Button
                    as='label'
                    htmlFor={modalId}
                    size='sm'
                    variant='ghost'
                    emphasis='accent-secondary'
                    aria-label='Выбрать бренд'
                    title='Выбрать бренд'
                    className='shrink-0 cursor-pointer'
                >
                    <Icon name='edit-2' size='sm' />
                </Button>
            </div>
            <BrandPickerDialog
                modalId={modalId}
                title={title}
                value={value}
                onSave={handleSave}
                isSaving={isSaving}
                error={error}
            />
        </>
    )
}
